var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.62,9.68,7,14H5L.38,9.68A1.23,1.23,0,0,1,0,8.77V1.17A1.09,1.09,0,0,1,1,0H11a1.09,1.09,0,0,1,1,1.17v7.6A1.23,1.23,0,0,1,11.62,9.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.33a61f42939bb2e59b64a2f1f6b46ef4.svg";
export { ForwardRef as ReactComponent };